module.exports = __webpack_public_path__ + "img/Invoice.62190108.svg";